import { create } from 'zustand'

interface BreadcrumbsState {
  currentRouteName: string
  resetName: () => void
  setName: (name: string) => void
}

export const useBreadcrumbsStore = create<BreadcrumbsState>((set) => ({
  currentRouteName: '',
  resetName: () => set({ currentRouteName: '' }),
  setName: (name: string) => set({ currentRouteName: name })
}))
